import { detect } from 'detect-browser';

const browser = detect();

// handle the case where we don't detect the browser
if (browser) {
  document.getElementsByTagName('html')[0].classList.add(browser.name);
}
